"use client"

import * as React from "react"
import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
// import { Calendar } from "@/components/ui/calendar"
// import {
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@/components/ui/popover"
import { Calendar } from "./calendar"
import { Popover, PopoverContent, PopoverTrigger } from "../popover"
import { Label } from "@/components/atoms/texts/label"
import { useEffect } from "react"

export function DatePicker({
    className,
    open: controlledOpen,
    setOpen: setControlledOpen,
    date: controlledDate,
    setDate: setControlledDate,
    onChange,
    disabled = false,
}) {
    const [uncontrolledOpen, setUncontrolledOpen] = React.useState(false);
    const [uncontrolledDate, setUncontrolledDate] = React.useState(() => {
        if (controlledDate !== undefined ) {
            if (controlledDate instanceof Date) {
                return controlledDate;
            } else if (controlledDate) {
                return new Date(controlledDate);
            }
        }
        return undefined;
    });

    const isControlled = controlledOpen !== undefined && setControlledOpen !== undefined;
    const isDateControlled = controlledDate !== undefined && setControlledDate !== undefined;

    const open = isControlled ? controlledOpen : uncontrolledOpen;
    const setOpen = isControlled ? setControlledOpen : setUncontrolledOpen;
    const date = isDateControlled ? controlledDate : uncontrolledDate;
    const setDate = isDateControlled ? setControlledDate : setUncontrolledDate;

    // Synchronise uncontrolledDate avec controlledDate si non contrôlé
    React.useEffect(() => {
        if (!isDateControlled) {
            let newDate = controlledDate instanceof Date ? controlledDate : (controlledDate ? new Date(controlledDate) : undefined);
            if (
                (newDate && uncontrolledDate && newDate.getTime() !== uncontrolledDate.getTime()) ||
                (newDate && !uncontrolledDate) ||
                (!newDate && uncontrolledDate)
            ) {
                setUncontrolledDate(newDate);
            }
        }
    }, [controlledDate]); // <-- dépend seulement de controlledDate

    // console.log("DatePicker rendered with date:", date, "controlledDate:", controlledDate, "uncontrolledDate:", uncontrolledDate, controlledDate ? new Date(controlledDate) : (controlledDate));

    useEffect(() => {
        if (date && date instanceof Date && !isNaN(date)) {
            // console.log("DatePicker date changed:", date);
            const displayDate = format(date, "dd/MM/yyyy");
            const isoDate = format(date, "yyyy-MM-dd"); // Format RFC3339
            onChange?.({ 
                target: { 
                    value: isoDate,
                    displayValue: displayDate
                } 
            });
            
        }
    }, [date]);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild >
                
                <Button
                    variant={"outline"}
                    className={cn(
                        " justify-start text-left font-normal bg-white w-full hover:bg-white ",
                        !date && "text-placeholder",
                        open && "ring-1 ring-medium ring-offset-2 ring-offset-primary ",
                        className
                    )}
                    
                
                >
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {date ? <Label>{format(date, "dd/MM/yyyy")}</Label> : <Label message="global.actions.select"></Label>}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0">
                <Calendar
                    mode="single"
                    selected={date}
                    onSelect={setDate}
                    initialFocus
                    defaultMonth={date instanceof Date && !isNaN(date) ? date : undefined}
                    captionLayout="dropdown"
                    disabled={disabled}


                />
            </PopoverContent>
        </Popover>
    )
}
